"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlanSchedule_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientResponsibleParty_1 = require("./PatientResponsibleParty");
var PaymentPlanTransaction_1 = require("./PaymentPlanTransaction");
var PaymentPlan_1 = require("./PaymentPlan");
var OrthoContractFrequency_1 = require("./OrthoContractFrequency");
var ScheduledPayment_1 = require("./ScheduledPayment");
var Transaction_1 = require("./Transaction");
var PaymentPlanSchedule_Factory = /** @class */ (function () {
    function PaymentPlanSchedule_Factory() {
    }
    PaymentPlanSchedule_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            AmountPayed: model.AmountPayed,
            AmountRemaining: model.AmountRemaining,
            Delay: model.Delay,
            DueDay: model.DueDay,
            ExpectedNow: model.ExpectedNow,
            LastPaymentDate: Date_Factory_1.Date_Factory.CreateIncoming(model.LastPaymentDate, { ignoreTimePortion: true }),
            NextPaymentDate: Date_Factory_1.Date_Factory.CreateIncoming(model.NextPaymentDate, { ignoreTimePortion: true }),
            NextPaymentDateSaved: Date_Factory_1.Date_Factory.CreateIncoming(model.NextPaymentDateSaved, { ignoreTimePortion: true }),
            PatientResponsibleParty: PatientResponsibleParty_1.PatientResponsibleParty_Factory.CreateIncoming(model.PatientResponsibleParty),
            PatientResponsiblePartyId: model.PatientResponsiblePartyId,
            PaymentAmount: model.PaymentAmount,
            PaymentCount: model.PaymentCount,
            PaymentOnLastDayOfMonth: model.PaymentOnLastDayOfMonth,
            PaymentPlanTransactions: model.PaymentPlanTransactions && model.PaymentPlanTransactions.map(function (i) { return PaymentPlanTransaction_1.PaymentPlanTransaction_Factory.CreateIncoming(i); }),
            Payments: model.Payments && model.Payments.map(function (i) { return i; }),
            Plan: PaymentPlan_1.PaymentPlan_Factory.CreateIncoming(model.Plan),
            PlanFrequency: OrthoContractFrequency_1.OrthoContractFrequency_Factory.CreateIncoming(model.PlanFrequency),
            PlanFrequencyCode: model.PlanFrequencyCode,
            PlanId: model.PlanId,
            Rank: model.Rank,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RemainingPaymentCount: model.RemainingPaymentCount,
            ScheduledPayments: model.ScheduledPayments && model.ScheduledPayments.map(function (i) { return ScheduledPayment_1.ScheduledPayment_Factory.CreateIncoming(i); }),
            Transactions: model.Transactions && model.Transactions.map(function (i) { return Transaction_1.Transaction_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    PaymentPlanSchedule_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            AmountPayed: model.AmountPayed,
            AmountRemaining: model.AmountRemaining,
            Delay: model.Delay,
            DueDay: model.DueDay,
            ExpectedNow: model.ExpectedNow,
            LastPaymentDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastPaymentDate, { ignoreTimePortion: true }),
            NextPaymentDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.NextPaymentDate, { ignoreTimePortion: true }),
            NextPaymentDateSaved: Date_Factory_1.Date_Factory.CreateOutgoing(model.NextPaymentDateSaved, { ignoreTimePortion: true }),
            PatientResponsibleParty: PatientResponsibleParty_1.PatientResponsibleParty_Factory.CreateOutgoing(model.PatientResponsibleParty),
            PatientResponsiblePartyId: model.PatientResponsiblePartyId,
            PaymentAmount: model.PaymentAmount,
            PaymentCount: model.PaymentCount,
            PaymentOnLastDayOfMonth: model.PaymentOnLastDayOfMonth,
            PaymentPlanTransactions: model.PaymentPlanTransactions && model.PaymentPlanTransactions.map(function (i) { return PaymentPlanTransaction_1.PaymentPlanTransaction_Factory.CreateOutgoing(i); }),
            Payments: model.Payments && model.Payments.map(function (i) { return i; }),
            Plan: PaymentPlan_1.PaymentPlan_Factory.CreateOutgoing(model.Plan),
            PlanFrequency: OrthoContractFrequency_1.OrthoContractFrequency_Factory.CreateOutgoing(model.PlanFrequency),
            PlanFrequencyCode: model.PlanFrequencyCode,
            PlanId: model.PlanId,
            Rank: model.Rank,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RemainingPaymentCount: model.RemainingPaymentCount,
            ScheduledPayments: model.ScheduledPayments && model.ScheduledPayments.map(function (i) { return ScheduledPayment_1.ScheduledPayment_Factory.CreateOutgoing(i); }),
            Transactions: model.Transactions && model.Transactions.map(function (i) { return Transaction_1.Transaction_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return PaymentPlanSchedule_Factory;
}());
exports.PaymentPlanSchedule_Factory = PaymentPlanSchedule_Factory;
